<div class="dialog-container">
  <div class="dialog-header">
    @if (step === 1) {
      <h1 class="dialog-title">Importador de Pessoas</h1>
    }
    @if (step === 2) {
      <h1 class="dialog-title">Pré-visualização da importação</h1>
    }

    <button mat-icon-button (click)="cancelar()" tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (step === 1) {
    <div class="dialog-content">
      <div class="actions-row">
        <input #fileInput type="file" (change)="onFileSelected($event)" accept=".csv" hidden />
        <button
          mat-flat-button
          color="primary"
          class="btn-primary"
          (click)="fileInput.click()"
          [disabled]="isLoading">
          @if (!isLoading) {
            <mat-icon class="material-symbols-outlined">upload</mat-icon>
          }
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          {{ isLoading ? '' : 'carregar planilha de pessoas' }}
        </button>
        <button mat-button (click)="downloadModelo()">
          <mat-icon class="material-symbols-outlined">download</mat-icon>
          download da planilha de exemplo
        </button>
      </div>
      <p class="instructions-text">
        Serão considerados os campos ID, CPF ou CNPJ para atualizar um contato já existente.<br />
        A coluna Contribuinte é obrigatória em todas as linhas: 1 - Contribuinte ICMS, 2 - Contribuinte isento de inscrição ou 9 - Não contribuinte.<br />
        Selecione um arquivo no formato texto (.csv) separado por ";".<br />
        O arquivo deverá ser compatível com o layout fornecido pela ATS.<br />
        O tamanho do arquivo não deve ultrapassar 2Mb.
      </p>
      @if (errorMessage) {
        <mat-error class="mb-3 d-block">
          <mat-icon class="align-middle">error</mat-icon> {{ errorMessage }}
        </mat-error>
      }
      <div class="table-section">
        <h3 class="table-title">Exemplo de planilha compatível com o Sistema ERP</h3>
        <div class="table-container">
          <table mat-table [dataSource]="dataSourceExample">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let e">{{ e.id }}</td>
            </ng-container>
            <ng-container matColumnDef="codigo">
              <th mat-header-cell *matHeaderCellDef>Código</th>
              <td mat-cell *matCellDef="let e">{{ e.codigo }}</td>
            </ng-container>
            <ng-container matColumnDef="nome">
              <th mat-header-cell *matHeaderCellDef>Nome</th>
              <td mat-cell *matCellDef="let e">{{ e.nome }}</td>
            </ng-container>
            <ng-container matColumnDef="fantasia">
              <th mat-header-cell *matHeaderCellDef>Fantasia</th>
              <td mat-cell *matCellDef="let e">{{ e.fantasia }}</td>
            </ng-container>
            <ng-container matColumnDef="endereco">
              <th mat-header-cell *matHeaderCellDef>Endereço</th>
              <td mat-cell *matCellDef="let e">{{ e.endereco }}</td>
            </ng-container>
            <ng-container matColumnDef="numero">
              <th mat-header-cell *matHeaderCellDef>Número</th>
              <td mat-cell *matCellDef="let e">{{ e.numero }}</td>
            </ng-container>
            <ng-container matColumnDef="complemento">
              <th mat-header-cell *matHeaderCellDef>Compl.</th>
              <td mat-cell *matCellDef="let e">{{ e.complemento }}</td>
            </ng-container>
            <ng-container matColumnDef="bairro">
              <th mat-header-cell *matHeaderCellDef>Bairro</th>
              <td mat-cell *matCellDef="let e">{{ e.bairro }}</td>
            </ng-container>
            <ng-container matColumnDef="cep">
              <th mat-header-cell *matHeaderCellDef>CEP</th>
              <td mat-cell *matCellDef="let e">{{ e.cep }}</td>
            </ng-container>
            <ng-container matColumnDef="cidade">
              <th mat-header-cell *matHeaderCellDef>Município</th>
              <td mat-cell *matCellDef="let e">{{ e.cidade }}</td>
            </ng-container>
            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>UF</th>
              <td mat-cell *matCellDef="let e">{{ e.estado }}</td>
            </ng-container>
            <ng-container matColumnDef="fone">
              <th mat-header-cell *matHeaderCellDef>Fone</th>
              <td mat-cell *matCellDef="let e">{{ e.fone }}</td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>E-mail</th>
              <td mat-cell *matCellDef="let e">{{ e.email }}</td>
            </ng-container>
            <ng-container matColumnDef="website">
              <th mat-header-cell *matHeaderCellDef>Site</th>
              <td mat-cell *matCellDef="let e">{{ e.website }}</td>
            </ng-container>
            <ng-container matColumnDef="tipoPessoa">
              <th mat-header-cell *matHeaderCellDef>Tipo Pessoa</th>
              <td mat-cell *matCellDef="let e">{{ e.tipoPessoa }}</td>
            </ng-container>
            <ng-container matColumnDef="cpf">
              <th mat-header-cell *matHeaderCellDef>CPF</th>
              <td mat-cell *matCellDef="let e">{{ e.cpf }}</td>
            </ng-container>
            <ng-container matColumnDef="cnpj">
              <th mat-header-cell *matHeaderCellDef>CNPJ</th>
              <td mat-cell *matCellDef="let e">{{ e.cnpj }}</td>
            </ng-container>
            <ng-container matColumnDef="docEstrangeiro">
              <th mat-header-cell *matHeaderCellDef>Doc. Estr.</th>
              <td mat-cell *matCellDef="let e">{{ e.docEstrangeiro }}</td>
            </ng-container>
            <ng-container matColumnDef="ie">
              <th mat-header-cell *matHeaderCellDef>I.E.</th>
              <td mat-cell *matCellDef="let e">{{ e.ie }}</td>
            </ng-container>
            <ng-container matColumnDef="im">
              <th mat-header-cell *matHeaderCellDef>I.M.</th>
              <td mat-cell *matCellDef="let e">{{ e.im }}</td>
            </ng-container>
            <ng-container matColumnDef="situacao">
              <th mat-header-cell *matHeaderCellDef>Situação</th>
              <td mat-cell *matCellDef="let e">{{ e.situacao }}</td>
            </ng-container>
            <ng-container matColumnDef="observacoes">
              <th mat-header-cell *matHeaderCellDef>Obs.</th>
              <td mat-cell *matCellDef="let e">{{ e.observacoes }}</td>
            </ng-container>
            <ng-container matColumnDef="dataNascimento">
              <th mat-header-cell *matHeaderCellDef>Dt. Nasc.</th>
              <td mat-cell *matCellDef="let e">{{ e.dataNascimento }}</td>
            </ng-container>
            <ng-container matColumnDef="contribuinteIbsCbs">
              <th mat-header-cell *matHeaderCellDef>Contr. IBS/CBS</th>
              <td mat-cell *matCellDef="let e">{{ e.contribuinteIbsCbs }}</td>
            </ng-container>
            <ng-container matColumnDef="consumidorFinal">
              <th mat-header-cell *matHeaderCellDef>Cons. Final</th>
              <td mat-cell *matCellDef="let e">{{ e.consumidorFinal }}</td>
            </ng-container>
            <ng-container matColumnDef="emailNFe">
              <th mat-header-cell *matHeaderCellDef>Email NF-e</th>
              <td mat-cell *matCellDef="let e">{{ e.emailNFe }}</td>
            </ng-container>
            <ng-container matColumnDef="tiposContatos">
              <th mat-header-cell *matHeaderCellDef>Tipos Contatos</th>
              <td mat-cell *matCellDef="let e">{{ e.tiposContatos }}</td>
            </ng-container>
            <ng-container matColumnDef="contribuinte">
              <th mat-header-cell *matHeaderCellDef>Contribuinte</th>
              <td mat-cell *matCellDef="let e">{{ e.contribuinte }}</td>
            </ng-container>
            <ng-container matColumnDef="crt">
              <th mat-header-cell *matHeaderCellDef>CRT</th>
              <td mat-cell *matCellDef="let e">{{ e.crt }}</td>
            </ng-container>
            <ng-container matColumnDef="limiteCredito">
              <th mat-header-cell *matHeaderCellDef>Lim. Crédito</th>
              <td mat-cell *matCellDef="let e">{{ e.limiteCredito }}</td>
            </ng-container>
            <ng-container matColumnDef="inscricaoSuframa">
              <th mat-header-cell *matHeaderCellDef>Insc. Suframa</th>
              <td mat-cell *matCellDef="let e">{{ e.inscricaoSuframa }}</td>
            </ng-container>
            <ng-container matColumnDef="vendedorResponsavel">
              <th mat-header-cell *matHeaderCellDef>Vendedor Responsável</th>
              <td mat-cell *matCellDef="let e">{{ e.vendedorResponsavel }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsExample"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsExample"></tr>
          </table>
        </div>
      </div>
    </div>
  }

  @if (step === 2) {
    <div class="dialog-content">
      <div class="validation-header mb-3">
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'todos'"
          (click)="aplicarFiltro('todos')">
          <span class="metric-label">todos</span>
          <strong class="metric-value">{{ getResumoTotal() }}</strong>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'novos'"
          (click)="aplicarFiltro('novos')">
          <span class="metric-label"><span class="dot dot-green"></span> novos</span>
          <span class="metric-value-sm">{{ getResumoNovos() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'atualizados'"
          (click)="aplicarFiltro('atualizados')">
          <span class="metric-label"><span class="dot dot-blue"></span> atualizados</span>
          <span class="metric-value-sm">{{ getResumoAtualizados() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'avisos'"
          (click)="aplicarFiltro('avisos')">
          <span class="metric-label"><span class="dot dot-yellow"></span> advertências</span>
          <span class="metric-value-sm">{{ getResumoAvisos() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'erros'"
          (click)="aplicarFiltro('erros')">
          <span class="metric-label"><span class="dot dot-red"></span> erros</span>
          <span class="metric-value-sm">{{ getResumoErros() }}</span>
        </div>
      </div>
      <div class="table-container">
        <table mat-table [dataSource]="itemsFiltered">
          <ng-container matColumnDef="status" sticky>
            <th mat-header-cell *matHeaderCellDef class="w-status">Situação</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="w-status"
              [matTooltip]="getTooltip(element)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              <div class="status-dots">
                @if (element.acao === _acaoImportacaoEnum.Novo) {
                  <span class="dot dot-green"></span>
                }
                @if (element.acao === _acaoImportacaoEnum.Atualizar) {
                  <span class="dot dot-blue"></span>
                }
                @if (!element.isValido) {
                  <span class="dot dot-red"></span>
                }
                @if (element.isAlerta && element.isValido) {
                  <span class="dot dot-yellow"></span>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="linha">
            <th mat-header-cell *matHeaderCellDef>Linha</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.linha }}
            </td>
          </ng-container>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.id }}
            </td>
          </ng-container>
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef>Código</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.codigo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef>Nome</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.nome }}
            </td>
          </ng-container>
          <ng-container matColumnDef="fantasia">
            <th mat-header-cell *matHeaderCellDef>Fantasia</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.fantasia }}
            </td>
          </ng-container>
          <ng-container matColumnDef="endereco">
            <th mat-header-cell *matHeaderCellDef>Endereço</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.endereco }}
            </td>
          </ng-container>
          <ng-container matColumnDef="numero">
            <th mat-header-cell *matHeaderCellDef>Número</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.numero }}
            </td>
          </ng-container>
          <ng-container matColumnDef="complemento">
            <th mat-header-cell *matHeaderCellDef>Compl.</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.complemento }}
            </td>
          </ng-container>
          <ng-container matColumnDef="bairro">
            <th mat-header-cell *matHeaderCellDef>Bairro</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.bairro }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cep">
            <th mat-header-cell *matHeaderCellDef>CEP</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.cep }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cidade">
            <th mat-header-cell *matHeaderCellDef>Município</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.cidade }}
            </td>
          </ng-container>
          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>UF</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.estado }}
            </td>
          </ng-container>
          <ng-container matColumnDef="fone">
            <th mat-header-cell *matHeaderCellDef>Fone</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.fone }}
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>E-mail</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.email }}
            </td>
          </ng-container>
          <ng-container matColumnDef="website">
            <th mat-header-cell *matHeaderCellDef>Site</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.webSite }}
            </td>
          </ng-container>
          <ng-container matColumnDef="tipoPessoa">
            <th mat-header-cell *matHeaderCellDef>Tipo Pessoa</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.tipoPessoa }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cpf">
            <th mat-header-cell *matHeaderCellDef>CPF</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.cpf }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cnpj">
            <th mat-header-cell *matHeaderCellDef>CNPJ</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.cnpj }}
            </td>
          </ng-container>
          <ng-container matColumnDef="docEstrangeiro">
            <th mat-header-cell *matHeaderCellDef>Doc. Estr.</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.documentoEstrangeiro }}
            </td>
          </ng-container>
          <ng-container matColumnDef="ie">
            <th mat-header-cell *matHeaderCellDef>I.E.</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.inscricaoEstadual }}
            </td>
          </ng-container>
          <ng-container matColumnDef="im">
            <th mat-header-cell *matHeaderCellDef>I.M.</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.inscricaoMunicipal }}
            </td>
          </ng-container>
          <ng-container matColumnDef="situacao">
            <th mat-header-cell *matHeaderCellDef>Situação</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.situacao }}
            </td>
          </ng-container>
          <ng-container matColumnDef="observacoes">
            <th mat-header-cell *matHeaderCellDef>Obs.</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.observacoes }}
            </td>
          </ng-container>
          <ng-container matColumnDef="dataNascimento">
            <th mat-header-cell *matHeaderCellDef>Dt. Nasc.</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.dataNascimento }}
            </td>
          </ng-container>
          <ng-container matColumnDef="contribuinteIbsCbs">
            <th mat-header-cell *matHeaderCellDef>Contr. IBS/CBS</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.contribuinteIbsCbs }}
            </td>
          </ng-container>
          <ng-container matColumnDef="consumidorFinal">
            <th mat-header-cell *matHeaderCellDef>Cons. Final</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.isConsumidorFinal }}
            </td>
          </ng-container>
          <ng-container matColumnDef="emailNFe">
            <th mat-header-cell *matHeaderCellDef>Email NF-e</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.emailNFe }}
            </td>
          </ng-container>
          <ng-container matColumnDef="tiposContatos">
            <th mat-header-cell *matHeaderCellDef>Tipos Contatos</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.tiposDeContatos }}
            </td>
          </ng-container>
          <ng-container matColumnDef="contribuinte">
            <th mat-header-cell *matHeaderCellDef>Contribuinte</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.indicadorInscricaoEstadual }}
            </td>
          </ng-container>
          <ng-container matColumnDef="crt">
            <th mat-header-cell *matHeaderCellDef>CRT</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.codigoRegimeTributario }}
            </td>
          </ng-container>
          <ng-container matColumnDef="limiteCredito">
            <th mat-header-cell *matHeaderCellDef>Lim. Crédito</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.limiteCredito }}
            </td>
          </ng-container>
          <ng-container matColumnDef="inscricaoSuframa">
            <th mat-header-cell *matHeaderCellDef>Insc. Suframa</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.inscricaoSuframa }}
            </td>
          </ng-container>
          <ng-container matColumnDef="vendedorResponsavel">
            <th mat-header-cell *matHeaderCellDef>Vendedor Responsável</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.documentoVendedorResponsavel }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsPreview"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsPreview"
            [ngClass]="getRowClass(row)"></tr>
        </table>
        @if (itemsFiltered.length === 0) {
          <div class="empty-state p-4 text-center text-muted">Nenhum item encontrado neste filtro.</div>
        }
      </div>
    </div>
  }

  <div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
    <div class="actions-wrapper">
      @if (step === 1) {
        <button mat-stroked-button class="btn-secondary me-2 mobile-full-width" (click)="cancelar()">
          Cancelar
        </button>
      }

      @if (step === 2) {
        <button mat-stroked-button class="btn-secondary" (click)="voltarParaUpload()">
          <mat-icon>refresh</mat-icon> escolher outro arquivo
        </button>
        <div
          class="button-tooltip-wrapper mobile-full-width"
          [matTooltip]="getButtonTooltip()"
          [matTooltipDisabled]="!isImportDisabled">
          <button
            mat-flat-button
            class="btn-primary w-100"
            [disabled]="isImportDisabled || isLoading"
            (click)="confirmarImportacao()">
            @if (isLoading === true) {
              <mat-spinner [diameter]="20"></mat-spinner>
            } @else {
              <span class="material-symbols-outlined">check</span> meus dados estão corretos
            }
          </button>
        </div>
      }
    </div>
  </div>
</div>
